<template>
  <div class="tree-view">

    <context-menu v-if="contextMenu" :contextMenuItems="contextMenuItems"></context-menu>


    <drop-between-zone
        @nodeDrop="dropNodeAtPosition(0)"
        v-if="draggedNode !== null && draggedNode.data !== data[0]">
    </drop-between-zone>
    <template v-for="(nodeData, index) in nodesData">
      <tree-node v-if="!nodeData.hiddenByFilter"
          :key="nodeData[nodeKeyProp]"
          :recordsWithChosenFilters="recordsWithChosenFilters"
          :keyProp="nodeKeyProp"
          :renameOnDblClick="renameNodeOnDblClick"
          :childrenProp="nodeChildrenProp"
          :labelProp="nodeLabelProp"
          :data="nodeData"
          :draggable="nodesDraggable"
          :defaultIconClass="defaultIconClass"
          :iconClassProp="iconClassProp"
          :showIcon="showIcons"
          :prependIconClass="prependIconClass"
          :contextMenu="contextMenu"
          :treeView="this"
          ref="rootNodes"
          :multiSelect="multiSelect"
          @nodeSelect="nodeSelect"
          @nodeDragStart="nodeDragStart"
          @childNodeMultiSelect="childNodeMultiSelect"
          @deleteNode="deleteNode"
          @details="showDetails">
      </tree-node>
      <drop-between-zone
          @nodeDrop="dropNodeAtPosition(index + 1)"
          v-if="draggedNode !== null && draggedNode.data !== nodeData && (index + 1 >= data.length || draggedNode.data !== data[index + 1])">
      </drop-between-zone>
    </template>

  </div>

</template>

<script>

import TreeNode from './TreeNode.vue';
import DropBetweenZone from './DropBetweenZone.vue'
import ContextMenu from './ContextMenu.vue'

import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";

export default {
  name: "TreeView",
  props: {
    recordsWithChosenFilters: {default: null},
    query: {default: ""},
    multiSelect: {
      default: null
    },
    data: {
      type: Array,
      required: true
    },
    allowMultiple: {
      type: Boolean,
      default: false
    },
    nodeKeyProp: {
      type: String,
      default: 'id'
    },
    nodeChildrenProp: {
      type: String,
      default: 'children'
    },
    nodeLabelProp: {
      type: String,
      default: 'name'
    },
    nodesDraggable: {
      type: Boolean,
      default: false
    },
    contextMenu: {
      type: Boolean,
      default: false
    },
    contextMenuItems: {
      type: Array,
      default: () => [{code: 'DELETE_NODE', label: 'Delete node'}, {code: 'RENAME_NODE', label: 'Rename node'}]
    },
    renameNodeOnDblClick: {
      type: Boolean,
      default: false
    },
    // class added to every icon no matter what
    prependIconClass: {
      type: String,
      default: null
    },
    // default icon if node icon is not specified
    defaultIconClass: {
      type: String,
      default: null
    },
    // where to search for node icon
    iconClassProp: {
      type: String,
      default: "icon"
    },
    // show icons
    showIcons: {
      type: Boolean,
      default: false
    },
    initialSelection: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      nodesData: [],
      draggedNode: null,
      localMultiSelection: new Set(),

      selectionSize: 0
    }
  },
  mounted() {
      document.body.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
      document.body.removeEventListener('click', this.handleClickOutside);
  },
  model:{
    event: 'change',
    prop: 'initialSelection'
  },
  components: {
    TreeNode,
    DropBetweenZone,
    ContextMenu
  },
  watch:{
    data: function() {
      this.nodesData = this.data;
      this.refresh();
      this.refreshSearch(this.query);
    },
    query: function (q){
      this.refreshSearch(q);
    }
  },
  methods: {
    handleClickOutside(event) {
        const treeView = document.querySelector('.tree-view');
        if (treeView && !treeView.contains(event.target)) {
            if (this.selectedNode !== null) {
                this.selectedNode.deselect();
                this.selectedNode = null
                this.$emit("change", null);
            }
        }
    },
    childNodeMultiSelect(node, isSelected) {
      // forward event to the parent node
      if(!isSelected){
        this.localMultiSelection.delete(node.getKey());
      } else {
        this.localMultiSelection.add(node.getKey());
      }

      this.seletionSize = this.localMultiSelection.size;
      this.$emit(Events.treeViewNodeMultiSelect, node, isSelected)
    },

    refresh(){
      if(this.$refs.rootNodes) {
        this.createNodeMap();
      }
      if (this.selectedNode !== null) {
        this.selectedNode.deselect();
        this.selectedNode = null
        this.$emit("change", null);
      }
    },
    refreshSearch(q){
      let query = this.query;
      this.nodesData.forEach((el=> this.checkFilter(el, q)));
      this.nodesData = [...this.nodesData];
    },

    /**
     * @param el
     * @param q {string}
     * @return {number}
     */
    checkFilter(el, q){
      let elementsFound = 0;

      el.children?.forEach(child =>{
        elementsFound += this.checkFilter(child, q);
      });

      el.children = [...el.children];

      if(!q || el.name?.toLowerCase()?.includes(q.toLowerCase())){
        elementsFound++;
        el.hiddenByFilter = false;
        el.labelStyle = ""
        if (el.children.length > 0) {
          el.children.forEach(child => {
            elementsFound++;
            child.hiddenByFilter = false;
            child.labelStyle = "";
            if(child.children.length > 0) {
              child.children.forEach(grandchild => {
                elementsFound++;
                grandchild.hiddenByFilter = false;
                grandchild.labelStyle = "";
              })
            }
          })
        }
      } else {
        if(elementsFound === 0) {
          el.hiddenByFilter = true;
          el.labelStyle = ""
        } else{
          el.hiddenByFilter = false;
          el.labelStyle = "color:gray"
        }
      }
      return elementsFound;
    },

    expand(levels = 1){
      this.$refs.rootNodes.forEach(el => el.expand(levels));
    },
    createNodeMap() {
      if(this.$refs.rootNodes){
        if (this.nodeMap === undefined) {
          let nodeMap = this.nodeMap = new Map()
          let nodes = this.$refs.rootNodes.slice()
          for (let i = 0; i < nodes.length; i++) {
            let tmpNode = nodes[i]
            nodes.push(...tmpNode.getChildNodes())
          }
          for (let tmpNode of nodes) {
            nodeMap.set(tmpNode.data[this.nodeKeyProp], tmpNode) // TODO: change to getter
          }
        }
      }
    },
    getNodeByKey(key) {
      return this.nodeMap.get(key)
    },
    // event bubbles up to the roots
    nodeSelect(node, isSelected) {
      this.$emit(Events.treeViewNodeSelect, node, isSelected)
      if (isSelected) {
        if (this.selectedNode !== null) {
          this.selectedNode.deselect()
        }
        this.selectedNode = node
        this.$emit("change", this.selectedNode?.data);
      } else if (node === this.selectedNode) {
        this.selectedNode = null
        this.$emit("change", null);
      }
    },
    nodeDragStart() {
      this.$onEvent(Events.treeViewDropOK, this.cutNode)
    },
    cutNode() {
      console.log("TV cut");
      EventBus.$off(Events.treeViewDropOK)
      let idx = this.data.indexOf(window._bTreeView.draggedNodeData)
      this.data.splice(idx, 1)
      // let's notify that node data was successfully cut (removed from array)
      EventBus.$emit(Events.treeViewCutOK)
    },
    draggingStarted(draggedNode) {
      this.draggedNode = draggedNode
      // let's listen for the drag end event
      this.$onEvent(Events.treeViewNodeDragEnd, this.draggingEnded)
    },
    draggingEnded() {
      // stop listening for the dragging end event
      EventBus.$off(Events.treeViewNodeDragEnd, this.draggingEnded)
      this.draggedNode = null
    },
    dropNodeAtPosition(pos) {
      // position can change if we move node within the same parent node (same level)
      // so it's better to remember node at previous position
      let insertAfter = pos - 1 < 0 ? null : this.data[pos - 1]
      console.log("TV drop");

      this.$onEvent(Events.treeViewCutOK, () => {
        console.log("TV cut OK");

        let pos = this.data.indexOf(insertAfter) + 1
        this.data.splice(pos, 0, window._bTreeView.draggedNodeData)
        delete window._bTreeView.draggedNodeKey
        delete window._bTreeView.draggedNodeData
        EventBus.$off(Events.treeViewCutOK);
      })
      EventBus.$emit(Events.treeViewDropOK)
    },
    deleteNode(nodeData) {
      let nodes = this.data
      let idx = nodes.indexOf(nodeData)
      nodes.splice(idx, 1)
      this.$emit("change", null);
    },
    showDetails(data) {
      this.$emit("details", data);
    },
    menuItemSelected(item, node) {
      switch (item.code) {
        case 'DELETE_NODE':
          node.delete()
        case 'RENAME_NODE':
          node.startRenaming()
        default:
          this.$emit(Events.treeViewContextMenuItemSelected, item, node)
      }
    }
  },
  created() {
    this.selectConfirmationCallback = async () => true;
    this.selectedNode = null
    this.nodesData = this.data;
    this.$onEvent(Events.treeViewNodeDragStart, this.draggingStarted)
    this.$onEvent(Events.treeViewContextMenuItemSelected, this.menuItemSelected)
    this.$nextTick(() => {
      this.createNodeMap()
    })
  }
}
</script>

<style>
.tree-view {
  text-align: left;
}
</style>